<div class="vma-progress-wrap mx-auto" [ngClass]="spinnerTextColor"
     [ngStyle]="{'height': height+'px', 'width':height+'px'}">

  <div class="vma-picto"><img [src]="vmaPictoUrl" style="height: 100%"></div>
  <span class="vma-progress-value" [ngStyle]="{'line-height': height+'px'}">{{percent}}%</span>
  <span class="vma-progress-label">VMA</span>
  <mat-progress-spinner mode="determinate" [value]="percent"
                        class="vma-progress-spinner" [color]="spinnerColor"></mat-progress-spinner>
</div>